import React, { JSX } from 'react';
import Alert from './index';

interface Props {
  errors?: string | string[];
  className?: string;
}

export default function ErrorSection({ errors, className }: Props): JSX.Element | null {
  if (!errors) return null;

  const errorList = Array.isArray(errors) ? errors.filter(Boolean) : [errors];

  if (errorList.length === 0) {
    return null;
  }

  return (
    <>
      {errorList.map((error, index) => (
        <Alert key={index} type='danger' className={className}>
          {error}
        </Alert>
      ))}
    </>
  );
}
